module.exports = __webpack_public_path__ + "img/policia_estatal_down.17e70cff.svg";